import { render, staticRenderFns } from "./policyConfig.vue?vue&type=template&id=a5f34124&scoped=true"
import script from "./policyConfig.vue?vue&type=script&lang=js"
export * from "./policyConfig.vue?vue&type=script&lang=js"
import style0 from "./policyConfig.vue?vue&type=style&index=0&id=a5f34124&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f34124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f34124')) {
      api.createRecord('a5f34124', component.options)
    } else {
      api.reload('a5f34124', component.options)
    }
    module.hot.accept("./policyConfig.vue?vue&type=template&id=a5f34124&scoped=true", function () {
      api.rerender('a5f34124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/policyConfig.vue"
export default component.exports